
export default {
    namespaced: true,
    state: {
      user: null
    },
    getters: {
      getUserProfile(state, getters){
          if(state.user){
              return state.user.UserProfile;
          }

          return null;
      },
      /**
       * @return An ADAL user profile name.
       */
      getUserProfileName(state, getters) {
          let userProfile = getters.getUserProfile;
          if(userProfile){
              if(userProfile.FirstName && userProfile.LastName){
                  return userProfile.FirstName + " " + userProfile.LastName;
              }

              if(userProfile.FirstName){
                  return userProfile.FirstName;
              }

              if(userProfile.LastName){
                  return userProfile.LastName;
              }
          }

          return null;
      },
      getPermissions(state, getters){
          let userProfile = getters.getUserProfile;
          if(userProfile){
            return userProfile.Permissions;
          }

          return {};
      },
      getStores(state, getters){
          let userProfile = getters.getUserProfile;
          if(userProfile){
            return userProfile.Stores;
          }

          return {};
      },
      getDepartments(state, getters){
          let userProfile = getters.getUserProfile;
          if(userProfile){
            return userProfile.Departments;
          }

          return {};
      }
    },
    mutations: {
      updateUser(state, value){
        state.user = value;
      },
      removeUser(state){
        delete state.user;
      }
    },
    actions: {
  
    }
  }
  